.settingDescription {
    display: flex;
    flex-direction: column;
}

.settingRowContainer {
    display: flex;
    margin: 20px 0px;
    width: 100%;
    justify-content: space-between;
    align-items: flex-start;
}

.icon {
    color: var(--hps-light-blue);
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: 10px;
}

.hr {
    width: 100%;
    margin: 20px 0px;
}

.hr:last-of-type {
    display: none;
}